export default {
  common: {
    appName: 'ElderCare',
    loading: 'Cargando...',
    retry: 'Reintentar',
    goBack: 'Inicio',
    logout: 'Cerrar sesión',
    save: 'Guardar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    delete: 'Eliminar',
    edit: 'Editar',
    search: 'Buscar',
    weekDays: {
      sun: 'Dom',
      mon: 'Lun',
      tue: 'Mar',
      wed: 'Mié',
      thu: 'Jue',
      fri: 'Vie',
      sat: 'Sáb',
    },
  },
  nav: {
    home: 'Inicio',
    login: 'Iniciar sesión',
    dashboard: 'Panel',
    health: 'Salud',
    medication: 'Medicación',
    sos: 'Emergencia',
    family: 'Familia',
    article: 'Artículos',
    checkin: 'Registro',
    settings: 'Ajustes',
    about: 'Acerca de',
  },
  footer: {
    rights: 'Todos los derechos reservados',
    privacy: 'Política de privacidad',
    terms: 'Términos de servicio',
  },
  index: {
    hero: {
      title: 'ElderCare - Guardián de salud inteligente para mayores',
      subtitle: 'Plataforma de gestión de salud diseñada para personas mayores, manteniendo a las familias informadas y a los mayores sanos',
      cta: 'Comenzar',
      learnMore: 'Más información',
    },
    features: {
      title: 'Funciones principales',
      health: { title: 'Monitoreo de salud', desc: 'Registre presión arterial, glucosa y frecuencia cardíaca con alertas inteligentes' },
      medication: { title: 'Gestión de medicación', desc: 'Recordatorios y verificación de interacciones medicamentosas, nunca más olvide una dosis' },
      sos: { title: 'Llamada de emergencia', desc: 'SOS con un toque, notificación automática a la familia y compartición de ubicación' },
      family: { title: 'Cuidado familiar', desc: 'Monitoreo remoto, alertas instantáneas y compartición de datos para las familias' },
      article: { title: 'Artículos de salud', desc: 'Conocimiento sanitario autorizado y guías de bienestar personalizadas' },
      checkin: { title: 'Registro diario', desc: 'Seguimiento diario sencillo para construir hábitos saludables' },
    },
    elderly: {
      title: 'Diseño adaptado a mayores',
      desc: 'Diseñado para mayores: fácil de usar, ver y tocar',
      font: 'Fuentes grandes',
      touch: 'Áreas táctiles amplias',
      contrast: 'Colores de alto contraste',
    },
  },
  login: {
    title: 'ElderCare',
    loginTab: 'Iniciar sesión',
    registerTab: 'Registrarse',
    name: 'Nombre',
    email: 'Correo electrónico',
    password: 'Contraseña',
    role: 'Soy',
    elderRole: 'Mayor',
    familyRole: 'Familiar',
    bindCode: 'Código de vinculación',
    bindCodeHint: 'Ingrese el código de vinculación de la cuenta del mayor para asociar y ver los datos de salud',
    loginBtn: 'Iniciar sesión',
    registerBtn: 'Registrarse',
    verifyHint: 'Se enviará un correo de verificación a su dirección tras el registro',
    error: 'Operación fallida, por favor reintente',
    nameTooShort: 'El nombre debe tener al menos 2 caracteres',
    emailInvalid: 'Ingrese una dirección de correo electrónico válida',
    passwordTooShort: 'La contraseña debe tener al menos 8 caracteres',
  },
  dashboard: {
    title: 'Panel de salud',
    metrics: {
      bloodPressure: 'Presión arterial',
      bloodSugar: 'Glucosa en sangre',
      heartRate: 'Frecuencia cardíaca',
      weight: 'Peso',
      sleep: 'Sueño',
      temperature: 'Temperatura',
    },
    quickActions: 'Acciones rápidas',
    recordHealth: 'Registrar salud',
    takeMedicine: 'Tomar medicina',
    sos: 'Llamada de emergencia',
    checkinStatus: 'Registro de hoy',
    checkedIn: 'Registrado hoy',
    notCheckedIn: 'No registrado hoy',
    goCheckin: 'Registrarse',
    medicationReminders: 'Recordatorios de medicación',
    noReminders: 'Sin recordatorios de medicación',
    taken: 'Tomado',
  },
  health: {
    title: 'Registros de salud',
    inputTitle: 'Ingreso de datos',
    systolic: 'Sistólica (mmHg)',
    diastolic: 'Diastólica (mmHg)',
    bloodSugar: 'Glucosa (mmol/L)',
    heartRate: 'Frecuencia cardíaca (bpm)',
    weight: 'Peso (kg)',
    sleepHours: 'Sueño (horas)',
    temperature: 'Temperatura (°C)',
    submit: 'Enviar registro',
    trend: 'Tendencias',
    days: 'días',
    aiAnalysis: 'Análisis de salud por IA',
    analyze: 'Analizar',
    noAnalysis: 'Haga clic en el botón superior para obtener un informe de análisis de salud por IA',
    history: 'Historial',
    noHistory: 'Sin historial',
    chartLabelSystolic: 'Presión sistólica',
  },
  medication: {
    title: 'Gestión de medicación',
    currentPlan: 'Plan actual',
    noMedications: 'Sin medicamentos',
    addMedication: 'Agregar medicamento',
    name: 'Nombre del medicamento',
    dosage: 'Dosis',
    frequency: 'Frecuencia',
    freqDaily: 'Una vez al día',
    freqTwice: 'Dos veces al día',
    freqThree: 'Tres veces al día',
    freqWeekly: 'Una vez por semana',
    time: 'Hora de toma',
    startDate: 'Fecha de inicio',
    addBtn: 'Agregar',
    interactionWarning: 'Alerta de interacción medicamentosa',
    noInteraction: 'Sin riesgos de interacción medicamentosa',
    calendar: 'Calendario de medicación',
    invalidTimeFormat: 'Formato de hora inválido, use HH:mm (ej., 08:00, 20:00)',
  },
  sos: {
    title: 'Llamada de emergencia',
    holdToCall: 'Mantener para llamar',
    holdHint: 'Mantenga pulsado 1 segundo para activar la llamada de emergencia',
    sent: 'Llamada de emergencia enviada',
    sentDesc: 'Sus contactos de emergencia han sido notificados. Mantenga la calma y espere ayuda',
    contacts: 'Contactos de emergencia',
    location: 'Ubicación actual',
    loadingLocation: 'Obteniendo ubicación...',
    locationUnavailable: 'Ubicación no disponible',
    history: 'Historial SOS',
    noHistory: 'Sin registros SOS',
    confirmed: 'Confirmado',
    pending: 'Pendiente',
    sendFailed: 'Error al enviar alerta de emergencia, intente de nuevo',
    resolved: 'Resuelto',
  },
  family: {
    title: 'Cuidado familiar',
    members: 'Familia vinculada',
    noMembers: 'Sin familiares vinculados',
    bindCode: 'Código de vinculación',
    bindCodeHint: 'Comparta este código con sus familiares para vincular sus cuentas',
    invite: 'Invitar familiar',
    email: 'Correo del familiar',
    relationship: 'Relación',
    relSon: 'Hijo',
    relDaughter: 'Hija',
    relSpouse: 'Cónyuge',
    relSibling: 'Hermano/a',
    relOther: 'Otro',
    inviteBtn: 'Enviar invitación',
    notifications: 'Preferencias de notificación',
    prefAbnormal: 'Alerta de anomalía sanitaria',
    prefMedication: 'Recordatorio de medicación',
    prefSos: 'Alerta de emergencia',
    prefWeekly: 'Informe semanal',
    prefCheckin: 'Notificación de registro',
    dataSharing: 'Compartición de datos',
    shareDesc: 'Permitir que la familia consulte sus datos de salud',
  },
  article: {
    title: 'Artículos de salud',
    search: 'Buscar artículos...',
    noArticles: 'No se encontraron artículos',
    expand: 'Leer más',
    collapse: 'Ocultar',
    categories: {
      all: 'Todos',
      heart: 'Cardiovascular',
      diabetes: 'Diabetes',
      bone: 'Huesos',
      sleep: 'Sueño',
      nutrition: 'Nutrición',
      exercise: 'Ejercicio',
    },
  },
  checkin: {
    title: 'Registro diario',
    feeling: '¿Cómo se siente hoy?',
    feelings: {
      great: 'Excelente',
      good: 'Bien',
      normal: 'Normal',
      bad: 'Mal',
      terrible: 'Muy mal',
    },
    medication: 'Medicación hoy',
    yes: 'Sí',
    no: 'No',
    diet: 'Calificación de dieta',
    dietRatings: {
      good: 'Buena',
      normal: 'Normal',
      poor: 'Mala',
    },
    exercise: 'Ejercicio hoy',
    mood: 'Estado de ánimo',
    submit: 'Enviar registro',
    streak: 'Racha',
    streakDays: 'días',
    calendar: 'Calendario de registro',
  },
  settings: {
    title: 'Ajustes',
    profile: 'Perfil',
    name: 'Nombre de usuario',
    phone: 'Teléfono',
    birthday: 'Fecha de nacimiento',
    emergencyContact: 'Contacto de emergencia',
    save: 'Guardar cambios',
    preferences: 'Preferencias',
    language: 'Idioma',
    theme: 'Tema',
    light: 'Claro',
    dark: 'Oscuro',
    notifications: 'Notificaciones',
    notifHealth: 'Alertas de salud',
    notifMedication: 'Recordatorios de medicación',
    notifSos: 'Alertas de emergencia',
    notifCheckin: 'Recordatorios de registro',
    bindCode: 'Mi código de vinculación',
    changePassword: 'Cambiar contraseña',
    currentPassword: 'Contraseña actual',
    newPassword: 'Nueva contraseña',
    changePasswordBtn: 'Cambiar contraseña',
    dangerZone: 'Zona de peligro',
    deleteDesc: 'La eliminación de la cuenta es irreversible. Se perderán todos los datos',
    deleteAccount: 'Eliminar cuenta',
    deleteConfirm: '¿Está seguro? ¡Esta acción no se puede deshacer!',
  },
  about: {
    title: 'Acerca de ElderCare',
    subtitle: 'Guardián de salud inteligente para mayores',
    intro: 'Introducción',
    introContent: 'ElderCare es una plataforma de gestión de salud diseñada para personas mayores, que integra monitoreo inteligente de salud, gestión de medicación, llamadas de emergencia y más, para ayudar a los mayores a gestionar su salud manteniéndose conectados con su familia.',
    version: 'Información de versión',
    versionNumber: 'Número de versión',
    buildDate: 'Fecha de compilación',
    acknowledgements: 'Agradecimientos',
    contact: 'Contacto',
    contactEmail: "q3300404157{'@'}gmail.com",
    privacy: 'Política de privacidad',
    terms: 'Términos de servicio',
  },
  notfound: {
    message: 'Lo sentimos, la página que busca no existe',
    goHome: 'Ir al inicio',
  },
  privacy: {
    title: 'Política de privacidad',
    sections: {
      collection: {
        title: 'Recopilación de información',
        content: 'Solo recopilamos la información personal necesaria para prestar nuestros servicios, incluyendo los datos de registro (correo electrónico, nombre), los datos de salud (presión arterial, glucosa y otros indicadores) y la información del dispositivo. No recopilamos ninguna información personal no relacionada con nuestros servicios.',
      },
      usage: {
        title: 'Uso de la información',
        content: 'Su información personal solo se utiliza para proporcionar y mejorar nuestros servicios, incluyendo el análisis de datos de salud, alertas de anomalías, recordatorios de medicación y otras funciones esenciales. No utilizaremos su información para fines no autorizados.',
      },
      storage: {
        title: 'Almacenamiento de información',
        content: 'Sus datos se almacenan en servidores en la nube seguros con transmisión y almacenamiento cifrados. Tomamos medidas técnicas razonables para proteger la seguridad de sus datos e impedir el acceso no autorizado.',
      },
      sharing: {
        title: 'Compartición de información',
        content: 'Sin su consentimiento explícito, no compartiremos su información personal con terceros. Los datos de salud solo se compartirán con los familiares vinculados tras su autorización de conexión familiar.',
      },
      rights: {
        title: 'Sus derechos',
        content: 'Usted tiene derecho a acceder, corregir y eliminar su información personal, así como a retirar su consentimiento. Puede ejercer estos derechos a través de la configuración de la aplicación o contactando con nuestro equipo de soporte.',
      },
      security: {
        title: 'Seguridad',
        content: 'Utilizamos cifrado y medidas de seguridad conformes a los estándares del sector para proteger sus datos, incluyendo transmisión cifrada SSL, almacenamiento cifrado de datos y control de acceso. Revisamos y actualizamos periódicamente nuestras medidas de seguridad.',
      },
    },
  },
  terms: {
    title: 'Términos de servicio',
    sections: {
      acceptance: {
        title: 'Aceptación de los términos',
        content: 'Al usar esta aplicación, usted acepta cumplir con los presentes términos de servicio. Si no está de acuerdo con alguno de estos términos, por favor deje de usar esta aplicación. Nos reservamos el derecho de modificar estos términos en cualquier momento.',
      },
      service: {
        title: 'Descripción del servicio',
        content: 'ElderCare proporciona servicios de asistencia en gestión de salud, incluyendo el registro de datos de salud, recordatorios de medicación, llamadas de emergencia y otras funciones. Este servicio es solo a título informativo y no constituye asesoramiento médico, ni puede sustituir servicios médicos profesionales.',
      },
      accounts: {
        title: 'Gestión de cuentas',
        content: 'Necesita registrar una cuenta para usar las funciones esenciales de esta aplicación. Usted es responsable de mantener segura su contraseña y de todas las actividades realizadas bajo su cuenta. Si detecta un uso no autorizado de su cuenta, por favor notifíquenoslo inmediatamente.',
      },
      data: {
        title: 'Datos y privacidad',
        content: 'Valoramos la protección de su privacidad. Para las reglas detalladas de tratamiento de datos, consulte nuestra Política de privacidad. Usted conserva el control total sobre los datos de salud que envía.',
      },
      liability: {
        title: 'Limitación de responsabilidad',
        content: 'La información de salud proporcionada por esta aplicación es solo a título informativo y no constituye un diagnóstico ni un consejo de tratamiento médico. No somos responsables de las pérdidas derivadas del uso de la información de esta aplicación. Si tiene problemas de salud, consulte a un profesional sanitario cualificado.',
      },
      changes: {
        title: 'Modificaciones de los términos',
        content: 'Podemos actualizar estos términos de servicio periódicamente. Los cambios importantes se comunicarán mediante notificaciones en la aplicación o por correo electrónico. El uso continuado de esta aplicación constituye la aceptación de los términos actualizados.',
      },
    },
  },
  feedback: {
    title: 'Comentarios',
    subtitle: 'Sus comentarios son muy importantes para nosotros',
    name: 'Nombre',
    namePlaceholder: 'Ingrese su nombre (opcional)',
    email: 'Correo electrónico',
    emailPlaceholder: 'Ingrese su correo electrónico',
    subject: 'Asunto',
    subjectGeneral: 'Comentario general',
    subjectBug: 'Informe de error',
    subjectFeature: 'Sugerencia de función',
    subjectOther: 'Otro',
    message: 'Mensaje',
    messagePlaceholder: 'Describa sus comentarios en detalle...',
    submit: 'Enviar comentarios',
    submitting: 'Enviando...',
    success: '¡Comentarios enviados con éxito! Gracias por su aportación',
    error: 'Error al enviar comentarios, intente de nuevo más tarde',
  },
  verify: {
    loading: 'Verificando su correo electrónico...',
    success: '¡Verificación exitosa!',
    successDesc: 'Su correo electrónico ha sido verificado. Ahora puede iniciar sesión',
    failed: 'Verificación fallida',
    failedDesc: 'El enlace de verificación es inválido o ha expirado. Por favor reenvíe el correo de verificación',
    resend: 'Reenviar correo de verificación',
    resending: 'Enviando...',
    goLogin: 'Ir a iniciar sesión',
  },
  theme: {
    light: 'Claro',
    dark: 'Oscuro',
  },
}
